module.exports = __webpack_public_path__ + "static/media/stach_chest.d97d5a56.png";